export default "__VITE_ASSET__Lp7nZ$HS__"